export const translations = {
  en: {
    // Navbar
    nav: {
      about: 'About',
      projects: 'Projects',
      skills: 'Skills',
      education: 'Education',
      experience: 'Experience',
      contact: 'Contact'
    },
    // Header
    header: {
      greeting: 'Hello, my name is',
      tagline: 'and I like to simplify complicated things'
    },
    // About
    about: {
      title: 'About Me',
      paragraph1: 'At 22, I am a technology specialist driven by the intersection of data, automation, and user experience.',
      paragraph1Bold1: 'Systems Analysis',
      paragraph1Bold2: 'MBA in Big Data & Artificial Intelligence',
      paragraph1Rest: 'my career is defined by rapid technical growth.',
      paragraph2: 'Currently, I serve as an',
      paragraph2Bold1: 'L2 Technical Support Analyst at Reclame AQUI',
      paragraph2Rest: 'focusing on complex troubleshooting and critical bug fixes using',
      paragraph2Bold2: 'MongoDB and Elasticsearch',
      paragraph2End: 'to ensure platform reliability.',
      paragraph3: 'My Fullstack background helps me understand the architecture behind every issue, while I leverage automation tools like',
      paragraph3Bold1: 'n8n',
      paragraph3Bold2: 'Cursor',
      paragraph3Rest: 'to deliver high-quality software faster. Fully proficient in English (',
      paragraph3Bold3: 'C2 Level',
      paragraph3End: '), I am ready for global challenges that demand innovation and technical precision.'
    },
    // Education
    education: {
      title: 'Education',
      mba: {
        title: 'MBA in Big Data & Analytical Intelligence | 2024',
        institution: 'Descomplica Faculdade Digital',
        description: 'Specialization focused on advanced data analysis, Big Data architectures, and business intelligence, complementing my technical foundation with strategic and analytical vision.'
      },
      degree: {
        title: 'Systems Analysis & Development | 2022-2023',
        institution: 'Mogi das Cruzes University (UMC)',
        description: 'Full scholarship recipient (ProUni). During graduation, I developed full-stack, mobile, and desktop applications, consolidating knowledge in software engineering, agile methodologies, and project management.'
      },
      technical: {
        title: 'Industrial Mechanics Technician | 2019-2021',
        institution: 'ETEC Presidente Vargas',
        description: 'Technical education where I had my first contact with industrial automation. This experience sparked my interest in logic and programming, serving as the foundation for my transition to the technology field.'
      }
    },
    // Experience
    experience: {
      title: 'Professional Experience',
      reclame: {
        title: 'Reclame AQUI',
        position: 'L2 Technical Support Analyst (Jan 2025 – Present)',
        description: 'I act as a specialized technical escalation point for complex external customer incidents. I am responsible for bug diagnosis and platform performance maintenance, using',
        descriptionBold1: 'MongoDB',
        descriptionBold2: 'Elasticsearch',
        descriptionEnd: 'for log analysis and large-scale data manipulation.'
      },
      freelancer: {
        title: 'Freelancer',
        position: 'Full-stack Developer & AI Automation',
        description: 'Custom project development using React and Sass for the front-end and Java/Spring Boot for the back-end. I differentiate my deliveries through process automation with',
        descriptionBold1: 'n8n',
        descriptionBold2: 'Cursor (AI Code Editor)',
        descriptionEnd: 'to accelerate the development cycle and ensure code quality.'
      },
      newgo: {
        title: 'NewGo Tecnologia',
        position: 'Full-Stack Intern',
        description: 'Worked on API development and maintenance using Java 8, JavaScript, and SQL. Practical experience in Linux environments and Tomcat servers, working with agile methodologies and systems architecture.'
      }
    },
    // Projects
    projects: {
      title: 'Projects',
      cep: {
        title: 'CEP Finder',
        description: 'Mobile application that queries <br />the ViaCEP API, built with MVVM pattern.'
      },
      stock: {
        title: 'Stock Management Page',
        description: 'A stock management page that uses Java with Spring framework, along with JSP.'
      },
      api: {
        title: 'REST Product Registration API',
        description: 'A REST API built in Java 8 without the aid of persistence frameworks and libraries.'
      },
      portfolio: {
        title: 'This Portfolio :)',
        description: 'This portfolio is a React application in SPA architecture pattern, I used JavaScript, HTML and SCSS.'
      },
      coming: {
        title: 'Coming soon..',
        description: 'I will soon have new projects to showcase.'
      },
      link: 'Project Link'
    },
    // Skills
    skills: {
      title: 'Technologies I use'
    },
    // Contact
    contact: {
      title: 'Get in touch',
      subtitle: 'Send me an email:',
      namePlaceholder: 'Name',
      emailPlaceholder: 'Email',
      messagePlaceholder: 'Message',
      submitButton: 'Send email',
      success: 'Email sent successfully!',
      error: 'Error sending email. Please try again.',
      validation: 'Please fill in all form fields.'
    },
    // Footer
    footer: {
      text: '© 2025 Eduardo Victor Batalha de Oliveira. All rights reserved.'
    }
  },
  pt: {
    // Navbar
    nav: {
      about: 'Sobre',
      projects: 'Projetos',
      skills: 'Habilidades',
      education: 'Educação',
      experience: 'Experiência',
      contact: 'Contato'
    },
    // Header
    header: {
      greeting: 'Olá, me chamo',
      tagline: 'e gosto de simplificar coisas complicadas'
    },
    // About
    about: {
      title: 'Sobre Mim',
      paragraph1: 'Aos 22 anos, sou um entusiasta de tecnologia que acredita na união entre dados, automação e a experiência do usuário.',
      paragraph1Bold1: 'Análise e Desenvolvimento de Sistemas',
      paragraph1Bold2: 'MBA em Big Data e Inteligência Analítica',
      paragraph1Rest: 'minha trajetória é marcada por uma evolução técnica constante.',
      paragraph2: 'Atualmente, atuo como',
      paragraph2Bold1: 'Analista de Suporte Técnico N2 no Reclame AQUI',
      paragraph2Rest: 'onde realizo diagnósticos complexos e resolução de bugs críticos utilizando ferramentas como',
      paragraph2Bold2: 'MongoDB e Elasticsearch',
      paragraph2End: 'para garantir a estabilidade da plataforma.',
      paragraph3: 'Minha base como Desenvolvedor Fullstack permite-me compreender a arquitetura por trás dos problemas, enquanto utilizo ferramentas de automação como',
      paragraph3Bold1: 'n8n',
      paragraph3Bold2: 'Cursor',
      paragraph3Rest: 'para elevar o nível das minhas entregas. Fluente em inglês (',
      paragraph3Bold3: 'C2 Proficient',
      paragraph3End: '), estou preparado para desafios globais que exijam inovação e rigor técnico.'
    },
    // Education
    education: {
      title: 'Educação',
      mba: {
        title: 'MBA em Big Data e Inteligência Analítica | 2024',
        institution: 'Descomplica Faculdade Digital',
        description: 'Especialização focada em análise avançada de dados, arquiteturas de Big Data e inteligência de negócio, complementando minha base técnica com visão estratégica e analítica.'
      },
      degree: {
        title: 'Análise e Desenvolvimento de Sistemas | 2022-2023',
        institution: 'Universidade de Mogi das Cruzes (UMC)',
        description: 'Bolsista integral (ProUni). Durante a graduação, desenvolvi projetos full-stack, mobile e aplicações desktop, consolidando conhecimentos em engenharia de software, metodologias ágeis e gestão de projetos.'
      },
      technical: {
        title: 'Técnico em Mecânica Industrial | 2019-2021',
        institution: 'ETEC Presidente Vargas',
        description: 'Formação técnica onde tive meu primeiro contato com automação industrial. Essa experiência despertou meu interesse por lógica e programação, servindo como base para minha transição para a área de tecnologia.'
      }
    },
    // Experience
    experience: {
      title: 'Experiência Profissional',
      reclame: {
        title: 'Reclame AQUI',
        position: 'Analista de Suporte Técnico N2 (Jan 2025 – Presente)',
        description: 'Atuo como ponto de escalonamento técnico especializado para incidentes complexos de clientes externos. Sou responsável pelo diagnóstico de bugs e manutenção da performance da plataforma, utilizando',
        descriptionBold1: 'MongoDB',
        descriptionBold2: 'Elasticsearch',
        descriptionEnd: 'para análise de logs e manipulação de dados em larga escala.'
      },
      freelancer: {
        title: 'Freelancer',
        position: 'Desenvolvedor Full-stack & Automação IA',
        description: 'Desenvolvimento de projetos sob medida utilizando React e Sass para o front-end e Java/Spring Boot para o back-end. Diferencio minhas entregas através da automação de processos com',
        descriptionBold1: 'n8n',
        descriptionBold2: 'Cursor (AI Code Editor)',
        descriptionEnd: 'para acelerar o ciclo de desenvolvimento e garantir a qualidade do código.'
      },
      newgo: {
        title: 'NewGo Tecnologia',
        position: 'Estagiário Full-Stack',
        description: 'Atuação no desenvolvimento e manutenção de APIs utilizando Java 8, JavaScript e SQL. Experiência prática em ambiente Linux e servidores Tomcat, trabalhando com metodologias ágeis e arquitetura de sistemas.'
      }
    },
    // Projects
    projects: {
      title: 'Projetos',
      cep: {
        title: 'Buscador de CEP',
        description: 'Aplicação mobile que consulta <br />a API ViaCEP, construída com padrão MVVM.'
      },
      stock: {
        title: 'Página gestão de Estoque',
        description: 'É uma página de gerenciamento de estoque que utiliza Java com framework Spring, juntamente com JSP.'
      },
      api: {
        title: 'API Rest Cadastro Produto',
        description: 'É uma API no padrão REST construída em Java 8 sem auxilio de frameworks e bibliotecas de persistência.'
      },
      portfolio: {
        title: 'Este Portfólio :)',
        description: 'Esse portfólio é uma aplicação React no padrão de arquitetura SPA, utilizei JavaScript, HTML e SCSS.'
      },
      coming: {
        title: 'Em andamento..',
        description: 'Logo terei novos projetos para expor.'
      },
      link: 'Link para o Projeto'
    },
    // Skills
    skills: {
      title: 'Técnologias que uso'
    },
    // Contact
    contact: {
      title: 'Entre em contato',
      subtitle: 'Me envie um email:',
      namePlaceholder: 'Nome',
      emailPlaceholder: 'E-mail',
      messagePlaceholder: 'Mensagem',
      submitButton: 'Enviar e-mail',
      success: 'E-mail enviado com sucesso!',
      error: 'Erro ao enviar e-mail. Por favor, tente novamente.',
      validation: 'Por favor, preencha todos os campos do formulário.'
    },
    // Footer
    footer: {
      text: '© 2025 Eduardo Victor Batalha de Oliveira. Todos os direitos reservados.'
    }
  }
};

